import React, { useState } from 'react';
import { FaMinus, FaPlus } from 'react-icons/fa';
import { isEditable } from '../../utils/roles';
import { InputTransparent } from '../form/input.Transparent';

export const NumBig = props => {
  const {
    num,
    value,
    updateField,
    displayMod,
    showSlashValue = false,
    slashBaseValue,
    canEdit = true,
  } = props;
  const effectiveMod = typeof displayMod === 'number' ? displayMod : num.mod;

  const [editValue, setEditValue] = useState(false);
  const [editLabel, setEditLabel] = useState(false);
  const canInteract = isEditable() && canEdit;

  const sanitize = value => {
    if (typeof value === 'string' && value.trim() === '') {
      return '-';
    }
    return value;
  };

  const updateValue = value => {
    updateField(value, 'value');
    setEditValue(false);
  };

  const updateLabel = value => {
    updateField(sanitize(value), 'label');
    setEditLabel(false);
  };

  const baseValue =
    typeof value === 'number' && typeof num?.mod === 'number'
      ? value - num.mod
      : num?.value ?? 0;

  const setMod = newValue => {
    updateField(newValue, 'mod');
  };

  const updateMod = delta => {
    setMod(num.mod + delta);
  };

  const resetMod = () => setMod(0);
  const zeroOut = () => setMod(-baseValue);

  const baseDisplayValue = Number.isFinite(num?.value)
    ? num.value
    : Number.isFinite(baseValue)
    ? baseValue
    : 0;
  const slashDisplayValue = Number.isFinite(slashBaseValue)
    ? slashBaseValue
    : baseDisplayValue;
  const finalDisplayValue = Number.isFinite(value)
    ? value
    : baseDisplayValue + (Number.isFinite(effectiveMod) ? effectiveMod : 0);

  return (
    <div className='relative flex flex-col items-center justify-center w-full h-full'>
      {!editValue ? (
        <div className='flex items-center gap-1 parent-hover'>
            {canInteract && (
              <div
                className='cursor-pointer show-on-hover'
                onClick={() => updateMod(-1)}
                onContextMenu={e => {
                  e.preventDefault();
                  zeroOut();
              }}
            >
              <FaMinus />
            </div>
          )}
          <div
            onClick={() => canInteract && setEditValue(true)}
            className={`text-condensed text-2xl ${
              effectiveMod > 0
                ? 'text-primary-l'
                : effectiveMod < 0
                ? 'text-secondary'
                : 'text-contrast'
            } ${
              showSlashValue ? 'items-end gap-02' : 'items-center gap-1'
            } flex `}
          >
            {showSlashValue ? (
              <>
                {finalDisplayValue}
                <span className='text-contrast text-xs text-opacity-40'>/</span>
                <span className='text-contrast text-xs text-opacity-70'>
                  {slashDisplayValue}
                </span>
              </>
            ) : (
              value
            )}
          </div>
          {canInteract && (
            <div
              className='cursor-pointer show-on-hover'
              onClick={() => updateMod(1)}
              onContextMenu={e => {
                e.preventDefault();
                resetMod();
              }}
            >
              <FaPlus />
            </div>
          )}
        </div>
      ) : (
        <div className='flex'>
          {canInteract ? (
            <InputTransparent
              className='bg-transparent h-auto border-0 px-0 py-0 m-0 text-center text-condensed text-2xl'
              initValue={num.value === 0 ? '0' : num.value}
              onBlur={value => updateValue(value)}
            />
          ) : (
            <div className='text-condensed text-2xl'>
              {num.value === 0 ? '0' : num.value}
            </div>
          )}
        </div>
      )}
      <div className='flex items-center gap-1'>
        {editLabel && canInteract ? (
          <div
            onClick={() => canInteract && setEditLabel(true)}
            className='uppercase text-condensed text-xs text-contrast text-opacity-50'
          >
            {num.label}
          </div>
        ) : (
          <div>
            {canInteract ? (
              <InputTransparent
                className='bg-transparent h-auto border-0 px-0 py-0 m-0 text-center uppercase text-condensed text-xs text-contrast text-opacity-50'
                initValue={num.label}
                onBlur={value => updateLabel(value)}
              />
            ) : (
              <div className='uppercase text-condensed text-xs text-contrast text-opacity-50'>
                {num.label}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
